import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

export const stringifyQuery = (params: unknown): string => qs.stringify(params, { arrayFormat: 'repeat' });

export const createAxios = ({ host }: { host: string }): AxiosInstance =>
  axios.create({
    baseURL: host,
    paramsSerializer: stringifyQuery
  });
